export function linearPercentage(value, min, max) {
    const percentageValue = 100 * value / (max - min);
    if (percentageValue.toFixed(1) >= 1) {
        return '≈ ' + Math.round(percentageValue) + ' %';
    }
    return '≈ ' + percentageValue.toFixed(1) + ' %';
}

export function logarithmicPercentage(value, min, max) {
    if (value === "0" || value === "Off") {
        return '';
    }
    else {
        //const val = Math.pow(10, ((value - 1) / (253 / 3) - 1));
        const percentageValue = Math.pow(10, ((value - 1) / (253 / 3) - 1));
        if (percentageValue.toFixed(1) >= 1) {
            return '≈ ' + Math.round(percentageValue) + ' %';
        }
        return '≈ ' + percentageValue.toFixed(1) + ' %';
    }
}
